<span [innerHTML]="trustedValue" [title]="value"></span>